<div class="terms-page">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">
      <h1>Terms & Conditions</h1>
      <p class="subtitle">Please read these terms carefully before using our services. By using HoneyKode's services, you agree to be bound by these terms.</p>
      <p class="last-updated">Last Updated: {{ lastUpdated }}</p>
    </div>
  </section>

  <!-- Main Content -->
  <div class="content-container">
    <!-- Table of Contents Sidebar -->
    <aside class="toc-sidebar">
      <div class="toc-sticky">
        <h3>Table of Contents</h3>
        <nav class="toc-nav">
          <ul>
            <li *ngFor="let section of sections">
              <a [href]="'#' + section.id" class="toc-link">{{ section.title }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </aside>

    <!-- Terms Content -->
    <main class="terms-content">
      <div class="introduction">
        <h2>Welcome to HoneyKode</h2>
        <p>These Terms and Conditions ("Terms") govern your access to and use of HoneyKode's technology services, website, and platform. By accessing or using our Services, you acknowledge that you have read, understood, and agree to be bound by these Terms.</p>
        <p>These Terms apply to all visitors, users, and others who access or use the Services. Please read them carefully and contact us if you have any questions.</p>
        <div class="important-notice">
          <strong>Important:</strong> These Terms contain provisions that limit our liability and require individual arbitration for disputes. Please review these provisions carefully.
        </div>
      </div>

      <section *ngFor="let section of sections" [id]="section.id" class="terms-section">
        <h2>{{ section.title }}</h2>
        <div [innerHTML]="section.content"></div>
      </section>

      <!-- Payment and Fees Section -->
      <section class="terms-section">
        <h2>Payment and Fees</h2>
        <h3>9.1 Fees</h3>
        <p>You agree to pay all fees associated with your use of the Services as outlined in your service agreement or our pricing page. All fees are exclusive of applicable taxes unless otherwise stated.</p>

        <h3>9.2 Payment Terms</h3>
        <ul>
          <li>Payment is due according to the terms specified in your invoice or service agreement</li>
          <li>We accept payment via credit card, bank transfer, or other approved methods</li>
          <li>Late payments may be subject to interest charges and service suspension</li>
          <li>All fees are non-refundable except as expressly stated in a service agreement</li>
        </ul>

        <h3>9.3 Price Changes</h3>
        <p>We reserve the right to modify our pricing at any time. We will provide reasonable notice of price changes for ongoing services. Price changes will not affect active fixed-price projects.</p>

        <h3>9.4 Billing Disputes</h3>
        <p>If you believe you have been incorrectly billed, you must contact us within thirty (30) days of the billing date. Failure to do so constitutes acceptance of the charges.</p>
      </section>

      <!-- Confidentiality Section -->
      <section class="terms-section">
        <h2>Confidentiality</h2>
        <h3>10.1 Confidential Information</h3>
        <p>Both parties may have access to confidential information during the course of our relationship. Confidential information includes business plans, technical data, customer information, and other proprietary information.</p>

        <h3>10.2 Obligations</h3>
        <p>Each party agrees to:</p>
        <ul>
          <li>Maintain the confidentiality of the other party's confidential information</li>
          <li>Use confidential information only for the purposes of providing or receiving Services</li>
          <li>Not disclose confidential information to third parties without prior written consent</li>
          <li>Return or destroy confidential information upon request or termination</li>
        </ul>

        <h3>10.3 Exceptions</h3>
        <p>Confidentiality obligations do not apply to information that is publicly available, independently developed, or required to be disclosed by law.</p>
      </section>

      <!-- Additional Terms -->
      <section class="additional-terms">
        <h2>Additional Important Information</h2>
        <div class="info-grid">
          <div class="info-card">
            <h3>Service Level Agreement</h3>
            <p>Specific uptime and support commitments may be detailed in separate Service Level Agreements (SLAs) for enterprise customers.</p>
          </div>
          <div class="info-card">
            <h3>Beta Features</h3>
            <p>We may offer beta features or services. These are provided "as is" without warranties and may be discontinued at any time.</p>
          </div>
          <div class="info-card">
            <h3>Privacy Policy</h3>
            <p>Our <a routerLink="/privacy-policy">Privacy Policy</a> describes how we collect and use your information and is incorporated into these Terms by reference.</p>
          </div>
          <div class="info-card">
            <h3>Accessibility</h3>
            <p>We are committed to making our Services accessible. If you encounter accessibility issues, please contact us.</p>
          </div>
        </div>
      </section>

      <!-- Contact Section -->
      <section class="contact-section">
        <div class="contact-box">
          <h2>Questions About These Terms?</h2>
          <p>If you have questions or concerns about these Terms and Conditions, our legal team is here to help:</p>
          <div class="contact-methods">
            <div class="contact-method">
              <i class="icon-email"></i>
              <div>
                <strong>Legal Department</strong>
                <a href="mailto:legal@honeykode.com">legal@honeykode.com</a>
              </div>
            </div>
            <div class="contact-method">
              <i class="icon-phone"></i>
              <div>
                <strong>Phone</strong>
                <span>+1 (555) 123-4567</span>
              </div>
            </div>
          </div>
          <div class="cta-buttons">
            <a routerLink="/contact" class="btn-primary">Contact Us</a>
            <a routerLink="/privacy-policy" class="btn-secondary">View Privacy Policy</a>
          </div>
        </div>
      </section>

      <!-- Agreement Acknowledgment -->
      <section class="acknowledgment">
        <div class="acknowledgment-box">
          <h3>Acknowledgment</h3>
          <p>BY USING OUR SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS AND CONDITIONS, UNDERSTAND THEM, AND AGREE TO BE BOUND BY THEM. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE OUR SERVICES.</p>
        </div>
      </section>
    </main>
  </div>
</div>

<style>
.terms-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.hero-section {
  background: linear-gradient(135deg, #d946ef 0%, #9333ea 100%);
  color: white;
  padding: 80px 20px 60px;
  text-align: center;
}

.hero-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.subtitle {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  opacity: 0.95;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.last-updated {
  font-size: 0.95rem;
  opacity: 0.85;
  font-style: italic;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 20px;
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 40px;
  align-items: start;
}

.toc-sidebar {
  position: relative;
}

.toc-sticky {
  position: sticky;
  top: 100px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.toc-sticky h3 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1f2937;
}

.toc-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.toc-nav li {
  margin-bottom: 8px;
}

.toc-link {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.95rem;
  display: block;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
}

.toc-link:hover {
  background: #f3f4f6;
  color: #d946ef;
  transform: translateX(4px);
}

.terms-content {
  background: white;
  border-radius: 12px;
  padding: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.introduction {
  margin-bottom: 48px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f3f4f6;
}

.introduction h2 {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
}

.introduction p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 16px;
}

.important-notice {
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  padding: 16px 20px;
  margin-top: 24px;
  border-radius: 6px;
  font-size: 1rem;
  color: #92400e;
}

.important-notice strong {
  display: block;
  margin-bottom: 8px;
  color: #78350f;
}

.terms-section {
  margin-bottom: 48px;
  scroll-margin-top: 100px;
}

.terms-section h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.terms-section h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  margin-top: 24px;
  margin-bottom: 16px;
}

.terms-section p {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 16px;
}

.terms-section ol,
.terms-section ul {
  margin: 16px 0;
  padding-left: 24px;
}

.terms-section li {
  line-height: 1.8;
  color: #4b5563;
  margin-bottom: 12px;
}

.terms-section a {
  color: #d946ef;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.terms-section a:hover {
  color: #9333ea;
  text-decoration: underline;
}

.contact-info {
  background: #f9fafb;
  padding: 24px;
  border-radius: 8px;
  margin-top: 16px;
}

.contact-info p {
  margin-bottom: 8px;
}

.additional-terms {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #e5e7eb;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.info-card {
  background: #f9fafb;
  padding: 24px;
  border-radius: 8px;
  border-left: 4px solid #d946ef;
}

.info-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
}

.info-card p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #6b7280;
  margin: 0;
}

.info-card a {
  color: #d946ef;
  text-decoration: none;
  font-weight: 500;
}

.contact-section {
  margin-top: 64px;
  padding-top: 32px;
  border-top: 2px solid #e5e7eb;
}

.contact-box {
  background: linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%);
  padding: 40px;
  border-radius: 12px;
  text-align: center;
}

.contact-box h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.contact-box > p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 32px;
}

.contact-methods {
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.contact-method {
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
}

.contact-method strong {
  display: block;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 0.95rem;
}

.contact-method a,
.contact-method span {
  color: #d946ef;
  text-decoration: none;
  font-size: 1.05rem;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.2s, box-shadow 0.2s;
}

.btn-primary {
  background: linear-gradient(135deg, #d946ef 0%, #9333ea 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(217, 70, 239, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(217, 70, 239, 0.4);
}

.btn-secondary {
  background: white;
  color: #d946ef;
  border: 2px solid #d946ef;
}

.btn-secondary:hover {
  background: #faf5ff;
  transform: translateY(-2px);
}

.acknowledgment {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 2px solid #e5e7eb;
}

.acknowledgment-box {
  background: #1f2937;
  color: white;
  padding: 32px;
  border-radius: 12px;
  text-align: center;
}

.acknowledgment-box h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #d946ef;
}

.acknowledgment-box p {
  font-size: 0.95rem;
  line-height: 1.8;
  letter-spacing: 0.5px;
}

@media (max-width: 968px) {
  .content-container {
    grid-template-columns: 1fr;
  }

  .toc-sidebar {
    order: 2;
  }

  .toc-sticky {
    position: static;
  }

  .terms-content {
    order: 1;
    padding: 32px 24px;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }
}

@media (max-width: 640px) {
  .hero-section {
    padding: 60px 20px 40px;
  }

  .hero-content h1 {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1.1rem;
  }

  .terms-content {
    padding: 24px 16px;
  }

  .contact-methods {
    flex-direction: column;
    gap: 24px;
  }

  .contact-method {
    justify-content: center;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}
</style>
